import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoriesBento() {
  const { t } = useTranslation();

  const shoeImg = `https://readdy.ai/api/search-image?query=Designer%20sneakers%20pair%20on%20warm%20cream%20minimal%20backdrop%2C%20soft%20morning%20light%2C%20clean%20editorial%20product%20photography%2C%20neutral%20warm%20tones%2C%20elegant%20simplicity%2C%20subtle%20shadows%2C%20premium%20display&width=600&height=400&seq=bento-card-shoes-v2&orientation=landscape`;

  const hoodieImg = `https://readdy.ai/api/search-image?query=Plush%20gray%20hoodie%20sweater%20flat%20lay%20on%20warm%20oatmeal%20linen%20texture%2C%20soft%20natural%20daylight%2C%20minimal%20editorial%20style%2C%20cozy%20aesthetic%2C%20warm%20neutral%20background%2C%20clean%20fashion%20photography&width=600&height=400&seq=bento-card-hoodie-v2&orientation=landscape`;

  const tshirtImg = `https://readdy.ai/api/search-image?query=Crisp%20white%20cotton%20t-shirt%20folded%20neatly%20on%20warm%20beige%20surface%2C%20minimal%20editorial%20composition%2C%20soft%20natural%20light%20from%20window%2C%20clean%20product%20photography%2C%20warm%20neutral%20background%2C%20pure%20simplicity&width=600&height=400&seq=bento-card-tshirt-v2&orientation=landscape`;

  const jacketImg = `https://readdy.ai/api/search-image?query=Stylish%20bomber%20jacket%20on%20warm%20sand%20colored%20backdrop%2C%20soft%20afternoon%20light%2C%20minimal%20editorial%20style%2C%20clean%20fashion%20photography%2C%20earthy%20neutral%20tones%2C%20urban%20aesthetic%2C%20elegant%20display&width=600&height=400&seq=bento-card-jacket-v2&orientation=landscape`;

  const pantsImg = `https://readdy.ai/api/search-image?query=Casual%20pants%20and%20shorts%20collection%20with%20baseball%20cap%20on%20warm%20cream%20surface%2C%20minimal%20editorial%20style%2C%20soft%20natural%20light%2C%20clean%20composition%2C%20warm%20neutral%20tones%2C%20contemporary%20fashion%20photography&width=800&height=500&seq=bento-card-pants-v2&orientation=landscape`;

  const setsImg = `https://readdy.ai/api/search-image?query=Matching%20fashion%20sets%20with%20underwear%20and%20jersey%20items%20arranged%20artfully%20on%20light%20beige%20surface%2C%20minimal%20editorial%20composition%2C%20soft%20natural%20light%2C%20warm%20neutral%20background%2C%20clean%20product%20photography&width=1000&height=500&seq=bento-card-sets-v2&orientation=landscape`;

  const accessoriesImg = `https://readdy.ai/api/search-image?query=Fashion%20accessories%20including%20golden%20watch%20and%20minimal%20bracelet%20on%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20editorial%20product%20photography%2C%20elegant%20composition%2C%20warm%20neutral%20background%2C%20refined%20aesthetic&width=600&height=400&seq=bento-card-accessories-v2&orientation=landscape`;

  const beltsImg = `https://readdy.ai/api/search-image?query=Leather%20belts%20and%20perfume%20bottles%20arranged%20on%20warm%20cream%20surface%2C%20minimal%20editorial%20style%2C%20soft%20natural%20light%2C%20clean%20composition%2C%20warm%20neutral%20tones%2C%20lifestyle%20product%20photography%2C%20elegant%20display&width=600&height=400&seq=bento-card-belts-v2&orientation=landscape`;

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block text-xs tracking-[0.2em] uppercase text-foreground-400 font-semibold mb-3">
            {t('categories.title_label')}
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950">
            {t('categories.title')}
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            {t('categories.description')}
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

          {/* Card 1: Shoes + Hoodies - both text and image */}
          <a
            href={categories[0].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer min-h-[220px] border border-background-200/60"
          >
            <img src={shoeImg} alt="Shoes CSSBuy" className="absolute inset-0 w-full h-full object-cover object-top" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
            <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-end">
              <div className="w-9 h-9 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mb-3">
                <i className="ri-footprint-line w-4 h-4 flex items-center justify-center text-white"></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-white">{categories[0].name}</h3>
              <p className="text-sm text-white/70 mt-0.5">{categories[1].name}</p>
              <span className="inline-flex items-center gap-1 text-xs text-white/70 mt-2 group-hover:text-white transition-colors">
                Explorar <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
              </span>
            </div>
          </a>

          {/* Card 2: T-Shirts + Jackets - both text and image */}
          <a
            href={categories[2].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer min-h-[220px] border border-background-200/60"
          >
            <img src={tshirtImg} alt="T-Shirts CSSBuy" className="absolute inset-0 w-full h-full object-cover object-top" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
            <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-end">
              <div className="w-9 h-9 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mb-3">
                <i className="ri-t-shirt-air-line w-4 h-4 flex items-center justify-center text-white"></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-white">{categories[2].name}</h3>
              <p className="text-sm text-white/70 mt-0.5">{categories[3].name}</p>
              <span className="inline-flex items-center gap-1 text-xs text-white/70 mt-2 group-hover:text-white transition-colors">
                Explorar <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
              </span>
            </div>
          </a>

          {/* Card 3: Hoodies + Sweaters - image card */}
          <a
            href={categories[1].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer min-h-[220px] border border-background-200/60"
          >
            <img src={hoodieImg} alt="Hoodies CSSBuy" className="absolute inset-0 w-full h-full object-cover object-top" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
            <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-end">
              <div className="w-9 h-9 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mb-3">
                <i className="ri-t-shirt-line w-4 h-4 flex items-center justify-center text-white"></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-white">{categories[1].name}</h3>
              <span className="inline-flex items-center gap-1 text-xs text-white/70 mt-2 group-hover:text-white transition-colors">
                Explorar <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
              </span>
            </div>
          </a>

          {/* Card 4: Pants/Shorts + Headwear - image card */}
          <a
            href={categories[4].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer min-h-[220px]"
          >
            <img src={pantsImg} alt="Pants Shorts Headwear CSSBuy" className="absolute inset-0 w-full h-full object-cover object-top" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
            <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-end">
              <h3 className="text-lg font-heading font-bold text-white">{categories[4].name}</h3>
              <p className="text-sm text-white/80 mt-0.5">{categories[5].name}</p>
              <span className="inline-flex items-center gap-1 text-xs text-white/70 mt-2 group-hover:text-white transition-colors">
                Explorar <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
              </span>
            </div>
          </a>

          {/* Card 5: Sets + Underwear + Jersey - wide image card */}
          <a
            href={categories[6].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer min-h-[220px] md:col-span-2"
          >
            <img src={setsImg} alt="Sets Underwear Jersey CSSBuy" className="absolute inset-0 w-full h-full object-cover object-top" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/60 via-foreground-950/30 to-transparent"></div>
            <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end">
              <h3 className="text-xl font-heading font-bold text-white">{categories[6].name}</h3>
              <p className="text-sm text-white/80 mt-0.5">{categories[7].name} &middot; {categories[8].name}</p>
              <span className="inline-flex items-center gap-1 text-xs text-white/70 mt-2 group-hover:text-white transition-colors">
                Explorar <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
              </span>
            </div>
          </a>

          {/* Card 6: Jackets - image card */}
          <a
            href={categories[3].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer min-h-[220px] border border-background-200/60"
          >
            <img src={jacketImg} alt="Jackets CSSBuy" className="absolute inset-0 w-full h-full object-cover object-top" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
            <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-end">
              <div className="w-9 h-9 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mb-3">
                <i className="ri-contrast-2-line w-4 h-4 flex items-center justify-center text-white"></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-white">{categories[3].name}</h3>
              <span className="inline-flex items-center gap-1 text-xs text-white/70 mt-2 group-hover:text-white transition-colors">
                Explorar <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
              </span>
            </div>
          </a>

          {/* Card 7: Accessories + Bags - image card */}
          <a
            href={categories[9].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer min-h-[220px] border border-background-200/60"
          >
            <img src={accessoriesImg} alt="Accessories CSSBuy" className="absolute inset-0 w-full h-full object-cover object-top" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
            <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-end">
              <div className="w-9 h-9 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mb-3">
                <i className="ri-vip-crown-line w-4 h-4 flex items-center justify-center text-white"></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-white">{categories[9].name}</h3>
              <p className="text-sm text-white/70 mt-0.5">{categories[10].name}</p>
              <span className="inline-flex items-center gap-1 text-xs text-white/70 mt-2 group-hover:text-white transition-colors">
                Explorar <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
              </span>
            </div>
          </a>

          {/* Card 8: Belts + Perfumes + Other */}
          <a
            href={categories[11].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer min-h-[220px] border border-background-200/60"
          >
            <img src={beltsImg} alt="Belts Perfumes CSSBuy" className="absolute inset-0 w-full h-full object-cover object-top" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
            <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-end">
              <div className="w-9 h-9 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mb-3">
                <i className="ri-link w-4 h-4 flex items-center justify-center text-white"></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-white">{categories[11].name}</h3>
              <p className="text-sm text-white/70 mt-0.5">{categories[12].name} &middot; {categories[13].name}</p>
              <span className="inline-flex items-center gap-1 text-xs text-white/70 mt-2 group-hover:text-white transition-colors">
                Explorar <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
              </span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}